"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SEND_TIMEOUT = void 0;
exports["default"] = setSendTimeout;
var SET_SEND_TIMEOUT = 'WEB_CHAT/SET_SEND_TIMEOUT';
exports.SET_SEND_TIMEOUT = SET_SEND_TIMEOUT;
function setSendTimeout(sendTimeout) {
  return {
    type: SET_SEND_TIMEOUT,
    payload: {
      sendTimeout: sendTimeout
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfU0VORF9USU1FT1VUIiwiZXhwb3J0cyIsInNldFNlbmRUaW1lb3V0Iiwic2VuZFRpbWVvdXQiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFNlbmRUaW1lb3V0LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNFVF9TRU5EX1RJTUVPVVQgPSAnV0VCX0NIQVQvU0VUX1NFTkRfVElNRU9VVCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldFNlbmRUaW1lb3V0KHNlbmRUaW1lb3V0KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX1NFTkRfVElNRU9VVCxcbiAgICBwYXlsb2FkOiB7IHNlbmRUaW1lb3V0IH1cbiAgfTtcbn1cblxuZXhwb3J0IHsgU0VUX1NFTkRfVElNRU9VVCB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBTUEsZ0JBQWdCLEdBQUcsMkJBQTJCO0FBQUNDLE9BQUEsQ0FBQUQsZ0JBQUEsR0FBQUEsZ0JBQUE7QUFFdEMsU0FBU0UsY0FBY0EsQ0FBQ0MsV0FBVyxFQUFFO0VBQ2xELE9BQU87SUFDTEMsSUFBSSxFQUFFSixnQkFBZ0I7SUFDdEJLLE9BQU8sRUFBRTtNQUFFRixXQUFXLEVBQVhBO0lBQVk7RUFDekIsQ0FBQztBQUNIIn0=